

















































































































import Vue from 'vue';
import API from '@/api/common';
import util from '@/components/util';
import NOC from '@/class/common/const';
import SimpleList from '@/components/util/SimpleList.vue';
import SideMenuAlert from '@/components/util/SideMenuAlert.vue';
import MonthlyReport from './MonthlyReport.vue';

// validation
import VariableInput from '@/components/util/VariableInput.vue';

import * as alertModels from '@/class/models/views/alert';
import { moment } from '@/class';

import BasicGadget, {
  CFrame,
} from '@/components/gadgets/EditerBasicGadgetV3.vue';
import GraphTooltip from '@/parts/graph/GraphTooltip.vue';
import Gadgets from '@/components/gadgets';

import imageCompression from 'browser-image-compression';
import * as graphModels from '@/class/models/views/graph';
import * as Talert from '@/class/models/typed/alert';
import * as dashboardModels from '@/class/models/views/dashboard';
import { Route } from 'vue-router';

Vue.component('SimpleList', SimpleList);

export default Vue.extend({
  name: 'AlertList',
  // props: {
  //   appData: Object as PropOptions<IAPP>,
  //   alertID: String,
  // },
  components: {
    ...util, VariableInput,
    SimpleList,
    BasicGadget,
    GraphTooltip,
    SideMenuAlert,
    MonthlyReport,
  },
  data() {
    return {
      onload: false,
      mode: NOC.SETTING.MODE.NORMAL,
      selectedItem: '99' as string,
      setSideMenu: 'p99',
      nowPage: 0 as number,
      setModalData: {} as Talert.INewsAlert,
      legendLists: [] as Array<{
        index: number,
        legendList: graphModels.ILegend[],
      }>,
      tooltip: {} as graphModels.ITooltip,
      alertList: [] as Talert.INewsAlert[],
      alertRows: 0 as number,
      minAlertID: 0,
      showDetaile: false,
      // グラフ
      componentGadgets: Gadgets,
      gadget: {} as dashboardModels.IGadgetIndex,
      frameData: new CFrame(),
      initialCt1List: [] as dashboardModels.IGadgetSelectOptions[],
      isSp: false,
    };
  },
  computed: {
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    // アラートの種類
    alertCategories(): NOC.NEWS.ICategory[] {
      return [
        {title: 'すべての通知', type: '99', icon: 'fa-info-circle', background: '#FFE8E3', color: '#F43308'},
        {title: '残業', type: '1', icon: 'fa-info-circle', background: '#FFE8E3', color: '#F43308'},
        {title: '36協定', type: '10', icon: 'fa-info-circle', background: '#FFE8E3', color: '#F43308'},
        {title: 'インターバル', type: '2', icon: 'fa-info-circle', background: '#FFE8E3', color: '#F43308'},
        {title: '禁止アプリ', type: '90', icon: 'fa-info-circle', background: '#FFE8E3', color: '#F43308'},
        {title: 'レポート', type: '100', icon: 'fa-info-circle', background: '#DCE5F8', color: '#182863'},
      ];
    },

    moment(): any {
      return moment;
    },
  },
  async mounted() {
    this.initVue(this.$route);
  },

  // 同一URLでパラメータが変わったときに画面描画も行うように(詳細画面から他の詳細画面に遷移するため、queryの取得方法以外はmountedと同じにしている)
  async beforeRouteUpdate(to) {
    this.initVue(to, true);
  },
  created() {
    this.checkViewport();
    window.addEventListener('resize', this.checkViewport);
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewport);
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    checkViewport() {
      this.isSp = window.innerWidth < 650;
    },
    onScroll() {
      // スクロールしたらグラフツールチップを非表示にする
      if (this.tooltip.tooltipModel) {
        this.tooltip.tooltipModel.opacity = 0;
      }
    },
    changeItem(e: string) {
      this.selectedItem = e;
      this.setSideMenu = `c${e}`;
      const simpleList = this.$refs.SimpleList as any;
      if (simpleList && simpleList.$refs.paginate) {
        simpleList.$refs.paginate.selectFirstPage();
        simpleList.page = 0;
      }
      this.currentPage(0);
      this.getAlertList();
    },
    currentPage(value: number) {
      // console.log('currentPage', value);
      this.nowPage = value;
    },

    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    onClickCancel() {
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.showDetaile = false;
    },
    // selectAlertType(value: string) {
    //   // 引数に入ってきたselectedItemをNOC.ALERTの値に変換
    //   if (value === '2') {
    //     value = '1';
    //   } else if (value === '3') {
    //     value = '10';
    //   } else if (value === '4') {
    //     value = '2';
    //   } else if (value === '5') {
    //     value = '90';
    //   } else if (value === '6') {
    //     value = '100';
    //   } else if (value === '0') {
    //     value = '99';
    //   } else if (value === '1') {
    //     value = '99';
    //   }

    //   let newList = this.alertList.map((item) => ({ ...item}));
    //   newList = newList.filter((f) => String(f.type) === value);

    //   if (value === '99') {
    //     return this.alertList;
    //   } else {
    //     return newList;
    //   }
    // },
    backList() {
      // this.mode = NOC.SETTING.MODE.LIST;
      this.showDetaile = false;
    },
    clickItem(v: any) {
      this.selectedItem = v.itemID ? String(v.itemID) : '99';
      // this.showDetaile = false; // getAlertListに移動
    },
    clickParent(v: any) {
      // this.mode = NOC.SETTING.MODE.LIST;
      this.selectedItem = String(v.groupingID);
    },
    // util

    async openDetaile(data: Talert.INewsAlert, key: any) {
      await this.openModal(data, key);
      this.showDetaile = true;
    },
    async getAlertList(update?: boolean) {
      let value = this.selectedItem;
      if (value === '2') {
        value = '1';
      } else if (value === '3') {
        value = '10';
      } else if (value === '4') {
        value = '2';
      } else if (value === '5') {
        value = '90';
      } else if (value === '6') {
        value = '100';
      } else if (value === '0') {
        value = '99';
      } else if (value === '1') {
        value = '99';
      }
      if (this.nowPage === 0) {
        this.nowPage = 1;
      }
      const api = new API();
      const param = {
        currentAlertID: this.minAlertID,
        alertType: Number.parseInt(value, 10),
        countRecord: 10,
        pageNumber: this.nowPage,
      } as alertModels.VNewsAlertPagination;
      const res = await api.get<alertModels.VNewsAlert>('alert', param);
      if (!update) {
        this.showDetaile = false;
      }
      if (res.result) {
        // if (res.data.alert.length > 0) {
          // this.alertList = this.alertList.concat(res.data.alert);
          this.alertList = res.data.alert;
          if (res.data.alert.length > 0) {
            this.minAlertID = res.data.alert.reduce((a, b) =>
              a.alertID < b.alertID ? a : b,
            ).alertID;
          }
          this.alertRows = res.data.count;
        // }
      } else {
        this.$emit('change', NOC.APP.MODE.LOGIN);
      }
    },
    getGadgetName(gadgetName: string) {
      return gadgetName.indexOf('V3') === -1 ? gadgetName + 'V3' : gadgetName;
    },
    async downloadPdf() {
      const api = new API();
      const graphAreas = this.$refs.graphArea as any;
      const graphList = [];
      // console.log(graphAreas)
      for (let i = 0; i < graphAreas.length; i++) {
        // グラフのbase64URL作成
        const chartdom = graphAreas[i].$refs.chartdom;
        // let dataURL = '';
        let compressedURL = '';
        if (chartdom) {
          const mycanvas = chartdom.$refs.canvas;
          const canvas = document.createElement('canvas');
          canvas.width = mycanvas.width;
          canvas.height = mycanvas.height;
          const context = canvas.getContext('2d')!;
          context.fillStyle = 'rgb(255, 255, 255)';
          context.fillRect(0, 0, mycanvas.width, mycanvas.height);
          context.drawImage(mycanvas, 0, 0);
          // dataURL = canvas.toDataURL();
          // ファイルサイズ軽量化
          const gfile = await imageCompression.canvasToFile(canvas, 'png', 'g.png', 0);
          const compressedFile = await imageCompression(gfile, {
            maxSizeMB: 0.03,
          });
          compressedURL = await imageCompression.getDataUrlFromFile(compressedFile);
        }
        // 凡例
        const legendListObj = this.legendLists.find((v) => v.index === i);
        const legendList = legendListObj ? legendListObj.legendList : [];
        // アラートメッセージ、グラフ、凡例をまとめる
        graphList.push({
          text: (this.setModalData as alertModels.INewsAlert).texts[i],
          // url: dataURL.replace(/^.*,/, ''),
          url: compressedURL.replace(/^.*,/, ''),
          legendList,
        });

        // console.log(graphList)
      }
      // PDFダウンロード
      await api.post<Talert.IPdfDownload, any>('alert/pdf', {
        title: this.setModalData.title,
        date: this.setModalData.date,
        graphList,
      });
      // this.modal = false;
    },
    setTooltip(data: graphModels.ITooltip) {
      this.tooltip = JSON.parse(JSON.stringify(data));
    },
    setLegend(legendList: graphModels.ILegend[], index: number) {
      if (legendList.length) {
        const legendListParse = JSON.parse(JSON.stringify(legendList));
        const legendListObj = this.legendLists.find((v) => v.index === index);
        if (legendListObj) {
          legendListObj.legendList = legendListParse;
        } else {
          this.legendLists.push({ index, legendList: legendListParse });
        }
      }
    },
    async openModal(data: Talert.INewsAlert, key: number) {
      this.setModalData = data;
      await this.setAlertDetail(data);
    },
    changeCode(data: string) {
      return data ? data.replace(/\\n/g, '\n') : '';
    },
    async setAlertDetail(alertData: alertModels.INewsAlert) {
      // 本文未取得なら通信
      if (!alertData.text) {
        const api = new API();
        if (alertData.type === NOC.ALERT.TYPE.MONTHLY_REPORT) {
          // 月間レポート
          const res = await api.post<alertModels.VNewsAlertConfirmation, alertModels.IMonthlyReport>('alert/monthly-report', { alertID: alertData.alertID });
          if (res.result) {
            alertData.monthlyReport = res.data;
            alertData.checked = true;
            this.alertList.forEach((v) => {
              if (v.alertID === alertData.alertID) {
                v.checked = true;
              }
            });
            (this.$parent.$refs.topBar as any).updateDisplayedItem(alertData, alertData.alertID);
            // console.log(alertData.monthlyReport);
          }
        } else {
          // 36協定通知、インターバル通知、禁止アプリ通知
          const res = await api.post<
            alertModels.VNewsAlertConfirmation,
            alertModels.VNewsAlertDetail
          >('alert/select', { alertID: alertData.alertID });

          // console.log(res)

          if (res.result) {
            // alertData.category = 'alert';
            alertData.category = String(alertData.type);
            alertData.title = res.data.title;
            alertData.date = res.data.date;
            this.$set(alertData, 'texts', res.data.texts);
            alertData.graphs = res.data.graphs;
            alertData.checked = true;
            alertData.hasNext = res.data.hasNext;
            if (!this.initialCt1List.length) {
              this.initialCt1List = [{
                materialID: NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER.id,
                selectOptions: [],
              }];
            }
            const selectOptions = this.initialCt1List[0].selectOptions;
            const setDataValue = alertData.graphs[0].data.values.setData;
            if (!selectOptions.some((v) => v.value === setDataValue)) {
              selectOptions.push({
                value: alertData.graphs[0].data.values.setData,
                text: res.data.username,
              });
            }
            // this.editGadget = (res.data.graphs as any)[0];
            this.$emit('check-alert', res.data.uncheckedCount);
            this.alertList.forEach((v) => {
              if (v.alertID === alertData.alertID) {
                v.checked = true;
              }
            });
            (this.$parent.$refs.topBar as any).updateDisplayedItem(alertData, alertData.alertID);
          } else {
            this.$emit('change', NOC.APP.MODE.LOGIN);
          }
        }
      }
    },
    // 描画処理の共通化
    async initVue(route: Route, update?: boolean) {
      if (update) {
        this.onload = false;
      }
      this.$emit('pushPath', this.$route.path);
      // await this.getAlertList();

      this.frameData.nopulldown = true;
      this.frameData.noicons = true;

      const query = route.query;
      this.selectedItem = query.cat ? query.cat as string : '99';
      await this.getAlertList(update);

      if (query) {
        // すべての通知、36協定通知など
        const cat = query.cat as string;
        if (cat && cat !== '99') {
          this.selectedItem = cat;
          this.setSideMenu = `c${cat}`;
        }
        // 個別のアラート
        if (query.id) {
          this.setModalData.alertID = Number(query.id);
          await this.setAlertDetail(this.setModalData);
          this.showDetaile = true;
        }


        if (query.alertid) {
          this.setModalData.alertID = Number(query.alertid);
          this.setModalData.type = Number(query.alertType);
          this.setModalData.title = String(query.title);
          this.setModalData.date = String(query.date);
          await this.setAlertDetail(this.setModalData);
          this.showDetaile = true;
        }
      }
      // 読み込み完了
      this.onload = true;
    },
  },
});
